import { ScrollPanel } from 'primereact/scrollpanel';
import React from 'react'
import { Modal } from 'react-bootstrap'
import { FaArrowAltCircleRight } from "react-icons/fa";

const PreviewModal = ({ show, handleClose, data, option2, option4, option, option5 }) => {
    const selectedLevel = option2.find(item => item.value === data.level);
    const selectedMedia = option4.find(item => item.value === data.social_media)
    const selectedCategory = option.find(item => item.value === data.category)
    const selectedType = option5.find(item => item.value === data.type)


    return (
        <>
            <Modal
                className=" modalRights creator_new_task theme-modal custom-inputs"
                show={show}
                onHide={handleClose}
                backdrop="static"
                centered
            >
                <Modal.Header className='pb-2' closeButton style={{ borderBottom: "0" }}>
                </Modal.Header>
                <Modal.Body className='pt-0'>
                    <h5 className='text-center mb-3'>
                        Task Preview </h5>
                    <div className='account-block mb-0'>
                        <div className='d-flex align-items-center dim-border justify-content-between' style={{ marginBottom: "13px" }}>
                            <span>Task Category:</span>
                            <h6 style={{ fontSize: "14px" }}>{selectedCategory ? selectedCategory.name : "Not found"}</h6>
                        </div>
                        <div className='d-flex align-items-center dim-border justify-content-between' style={{ marginBottom: "13px" }}>
                            <span>Task Type:</span>
                            <h6 style={{ fontSize: "14px" }}>{selectedType ? selectedType.name : "Not found"}</h6>
                        </div>
                        <div className='d-flex align-items-center dim-border justify-content-between' style={{ marginBottom: "13px" }}>
                            <span>Social Media Type

                            </span>
                            <h6 style={{ fontSize: "14px" }}>{selectedMedia ? selectedMedia.name : "Not found"}</h6>
                        </div>
                        <div className='d-flex align-items-center dim-border justify-content-between' style={{ marginBottom: "13px" }}>
                            <span>Task Title:
                            </span>
                            <h6 style={{ fontSize: "14px" }}>{data.title}</h6>
                        </div>
                        <div className='d-flex align-items-center dim-border justify-content-between' style={{ marginBottom: "13px" }}>
                            <span>Experience Required:
                            </span>
                            <h6 style={{ fontSize: "14px" }}>{selectedLevel ? selectedLevel.name : "Not found"}</h6>
                        </div>

                        <div className='d-flex align-items-center dim-border justify-content-between' style={{ marginBottom: "13px" }}>
                            <span>No of submission
                                :
                            </span>
                            <h6 style={{ fontSize: "14px" }}>{data.max_submission}</h6>
                        </div>
                        <div className='d-flex align-items-center dim-border justify-content-between' style={{ marginBottom: "13px" }}>
                            <span>₹ Price ( Per submission )

                                :
                            </span>
                            <h6 style={{ fontSize: "14px" }}>{data.price}</h6>
                        </div>
                        <div className='d-flex align-items-center dim-border justify-content-between' style={{ marginBottom: "13px" }}>
                            <span>Due Date
                                :
                            </span>
                            <h6 style={{ fontSize: "14px" }}>{data.due_date}</h6>
                        </div>
                        {data.caption ? <div className='d-flex align-items-center dim-border justify-content-between' style={{ marginBottom: "13px" }}>
                            <span>Caption
                                :
                            </span>
                            <h6 style={{ fontSize: "14px" }}>{data.caption}</h6>
                        </div> : ""}
                        {data.hashtag ? <div className='d-flex align-items-center dim-border justify-content-between' style={{ marginBottom: "13px" }}>
                            <span>HashTag
                                :
                            </span>
                            <h6 style={{ fontSize: "14px" }}>{data.hashtag}</h6>
                        </div> : ""}
                        {data.url ? <div className='d-flex flex-column dim-border justify-content-between' style={{ marginBottom: "13px" }}>
                            <span>Url
                                :
                            </span>
                            <h6 style={{ fontSize: "14px", wordWrap:"break-word", width:"100%" }}>{data.url}</h6>
                        </div> : ""}

                        <div className='d-flex align-items-center dim-border justify-content-between' style={{ marginBottom: "13px" }}>
                            <span>Task Status
                                :
                            </span>
                            <h6 style={{ fontSize: "14px" }}>{data.task_status === "0" ? "Open" : data.task_status === "1" ? "Closed" : ""}</h6>
                        </div>
                        <div className='d-flex flex-column  dim-border justify-content-between mb-3'>
                            <span style={{ marginBottom: "5px" }}>Task Description:
                            </span>
                            <ScrollPanel style={{ width: '100%', height: '100px' }}>
                                <p className='text-dark' dangerouslySetInnerHTML={{ __html: data.description }} />


                            </ScrollPanel>
                        </div>
                    </div>
                </Modal.Body>
            </Modal >
        </>
    )
}

export default PreviewModal
